import React from 'react';
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";

import "../css/OrderProducts.css";
import moment from "moment/moment";
import {SUPPORT_MODAL_HIDE_CREDIT_INVOICE_ITEM, validateCreditInvoiceItem} from "../actions";

import { CreditForm } from "./FormikCreditForm";
import {getCreditSubTypeList} from "../../../selectors/credit_modal";

class InternalCreditInvoiceItemModal extends React.Component {
  render() {
    const {sub_type_list, modal, hide, validate} = this.props;
    moment.locale('fr');

    /* Set up defaults values min and max quantity */
    let minQuantity = modal.minQuantity || 1;
    let maxQuantity = modal.maxQuantity || 0;

    return <Modal
      show={modal && modal.show}
      animation={false}
      backdrop={true}
      onHide={() => hide()}
      keyboard={true}
    >
      <Modal.Body>
        <h4>{modal.label}</h4>
        {modal.alertWarning &&
          <div className="alert alert-warning" role="alert"><b>{modal.alertWarning}</b></div>
        }
        {modal.alertInfo &&
          <div className="alert alert-info" role="alert">{modal.alertInfo}</div>
        }
        <CreditForm
          sub_type_list={sub_type_list}
          quantity={maxQuantity} // default quantity = max (recredit all remaining)
          pricePerUnitQuantity={modal.totalPrice ? modal.totalPrice / modal.quantityBought : 0}
          subtype={modal.subtype}  // default value
          labelQuantity="Quantité à recréditer"
          validate={(values) => {
            console.log("validate credit invoice item form", values);
            validate(values.quantity, values.subtype, values.notes, modal);
          }}
          minQuantity={minQuantity}
          maxQuantity={maxQuantity}
        />
      </Modal.Body>
    </Modal>;
  }
}

export const CreditInvoiceItemModal = connect(
  (state) => ({
    "modal" : state.support.modalCreditInvoiceItem,
    "sub_type_list": getCreditSubTypeList(state),
  }),
  (dispatch) => {
    return {
      "hide": () => {
        dispatch({"type": SUPPORT_MODAL_HIDE_CREDIT_INVOICE_ITEM});
      },
      "validate": (quantity, subtype, notes, modal) => {
        dispatch(validateCreditInvoiceItem(
          quantity,
          subtype,
          notes,
          modal
        ));
      }
    };
  }
)(InternalCreditInvoiceItemModal);
